module.exports = __webpack_public_path__ + "img/fk.ef828f1.svg";